<template>
  <v-alert
    border="left"
    outlined
    :type="type"
    :value="true"
    icon="mdi-alert-circle"
    transition="scale-transition"
    dismissible
  >
    <h4 class="grow">
      {{ message }}
    </h4>
  </v-alert>
</template>

<script>
export default {
  name: "form-alert-component",
  props: {
    message: { type: String, default: "" },
    type: { type: String, default: "error" }
  }
};
</script>
